/*eslint-disable */
<template>
  <b-container fluid>
    <b-row style="height: 800px;">
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">{{ cvCardTitle }}</h4>
          </template>
          <template v-slot:body>
            <p v-if="!propOpenedInModal">{{ cvCardSubHeader }}</p>
            <form action="#">
              <div class="form-row p-2">
                <div class="col-md-12 mb-3">
                  <label for="validationsubject_module_name">{{cvSubjectNameLabel}}&nbsp;<span class="primary-color" @click="openInterestList">(View Interests)</span></label>
                  <select v-model="vmSubjectModuleFormData.interest_id" class="form-control"  style="text-transform: capitalize;">
                    <option  v-for="(subModName, index) of subjectModuleName" :key="(index+1)" :value="subModName" >
                      {{subModName.interest_name}}
                    </option>
                  </select>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationsubject_module_name">{{cvSubjectModuleNameLabel}}</label>&nbsp;<small class="primary-color">(Set a name only if you want a new quiz/app to get created)</small>
                  <input v-model="vmSubjectModuleFormData.subject_module_name" type="text" class="form-control" required/>
                </div>
                <div class="col-md-12 mb-3 primary-color"><b>OR</b></div>
                <div class="col-md-12 mb-3">
                  <span>Select a quiz and attach it to <span class="primary-color">{{vmSubjectModuleFormData.interest_id.interest_name}}</span></span>
                  <multiselect
                    v-model="vmSubjectModuleFormData.attachedApp"
                    :options="appOptions"
                    placeholder="Quiz to be attached"
                    label="app_name"
                    track-by="app_name"
                  >
                  </multiselect>
                </div>
              </div>
              <div class="form-group">
                <button v-if="cvLoadingStatus" type="button" class="btn btn-primary" :disabled="cvLoadingStatus">
                  <b-spinner label="Spinning"></b-spinner>
                </button>
                <button type="button" class="btn btn-primary" @click="tprepSubjectModuleAdd()">
                  {{ cvSubmitBtn }}
                </button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast
      v-model="showToast"
      name="Toast"
      :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
      :variant="toastVariant"
      :title="toastTitle"
    >
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { TPrepSubjectModules } from "../../../FackApi/api/TPrepSubjectModule.js"
import ApiResponse from "../../../Utils/apiResponse.js"
import { Interests } from "../../../FackApi/api/interest.js"
import { socialvue } from "../../../config/pluginInit.js"
import userPermission from "../../../Utils/user_permission.js"
import { Apps } from "../../../FackApi/api/apps.js"
import Multiselect from "vue-multiselect"

export default {
  name: "TPrepSubjectModuleAdd",
  components: {
    Multiselect
  },
  data () {
    return {
      apiName: "tprep_subject_module_add",
      cvCardTitle: "Add TestSeries Module",
      cvCardSubHeader: "Add TestSeries Module ",
      cvSubmitBtn: "Add",
      cvSubjectNameLabel: "Interest/Subject/Exam Name",
      cvSubjectModuleNameLabel: "New App/Quiz Name",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      cvLoadingStatus: false,
      toastTitle: "TestSeries Response",
      vmSubjectModuleFormData: Object.assign({}, this.initFormData()),
      vmSubjectModuleDesc: null,
      vmSubjectModuleType: null,
      // InterestType: "SUBJ",
      subjectModuleName: [],
      subModName: "",
      appOptions: [],
      whereFilter: {
        quiz_type: "testseries",
        event_state: 2 // Active
      }
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  async mounted () {
    socialvue.index()
    await this.appList()
    await this.interestList()
  },
  methods: {
    /**
     * initFormData
     */
    initFormData () {
      return {
        "interest_id": "",
        "subject_module_name": "",
        "attachedApp": null,
        "app_id": null,
        "app_category": null
      }
    },
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmSubjectModuleFormData) {
          if (!this.vmSubjectModuleFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
      }
    },
    async interestList (interestType) {
      try {
        let interestObj = {
          "page": this.page
        }
        let interestListResp = await Interests.interestWithCategoryList(this, interestObj, interestType)
        if (interestListResp.resp_status) {
          this.interestObjList = interestListResp.resp_data

          this.subjectModuleName = this.interestObjList.INTERESTCAT11117
          this.interestCatObjList = interestListResp.resp_data_1

          for (let intCat in this.interestCatObjList) {
            this.interestCatLimit[this.interestCatObjList[intCat].interest_cat_id] = this.ITEM_LIMIT
          }
          this.totalRows = interestListResp.resp_data.count
        }
        else {
          this.toastMsg = interestListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.error("Exception occurred at interestList() and Exception:", err.message)
      }
    },
    /**
     * appList
     */
    async appList () {
      try {
        let quizListResp = await Apps.appListConsole(this, this.whereFilter)
        if (quizListResp.resp_status) {
          this.appOptions = quizListResp.resp_data.data
        }
      }
      catch (err) {
        console.log("Exception occurred at appList() and Exception:", err.message)
      }
    },
    /**
     * tprepSubjectModuleAdd
     */
    async tprepSubjectModuleAdd () {
      try {
        this.cvLoadingStatus = true
        this.vmSubjectModuleFormData.subject_module_name = this.vmSubjectModuleFormData.interest_id.interest_name + "-" + this.vmSubjectModuleFormData.subject_module_name
        this.vmSubjectModuleFormData.app_category = this.vmSubjectModuleFormData.interest_id.interest_name
        this.vmSubjectModuleFormData.interest_id = this.vmSubjectModuleFormData.interest_id.interest_id
        this.vmSubjectModuleFormData.subject_module_name = this.vmSubjectModuleFormData?.attachedApp?.app_name ? this.vmSubjectModuleFormData.attachedApp.app_name : this.vmSubjectModuleFormData.subject_module_name
        this.vmSubjectModuleFormData.app_id = this.vmSubjectModuleFormData?.attachedApp?.app_id ? this.vmSubjectModuleFormData?.attachedApp?.app_id : null

        let subjectModuleAddResp = await TPrepSubjectModules.tprepSubjectModuleAdd(this, this.vmSubjectModuleFormData)
        await ApiResponse.responseMessageDisplay(this, subjectModuleAddResp)
        if (subjectModuleAddResp && !subjectModuleAddResp.resp_status) {
          return false
        }
        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitCloseSubjectModuleAddModal", subjectModuleAddResp.resp_data)
        }
        this.vmSubjectModuleFormData = Object.assign({}, this.initFormData())
      }
      catch (err) {
        console.error("Exception occurred at tprepSubjectModuleAdd() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * open Interest List
     */
    openInterestList () {
      window.open("interest_list", "_blank")
    }
  }
}
</script>
